import * as React from 'react';
import {
    getReactAccordion,
    getReactButton,
} from "../../index";
import {RefObject} from "react";

export interface JSONCellData {
    className?: string,
    style?: {},
    displayValue?: any,
    displayOverride?: (rowObj: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, disabled: boolean, levelCount: number) => {},
    jsonData: { [key: string]: any },
    jsonParentObject?: {},
    jsonKey: string,
    jsonParentKey: string,
    arrayIndex: number,
    hierarchyIndex?: number,
    title?: string,
    disabled?: boolean,
    levelCount?: number,
}

class ReactJSONCell extends React.Component<JSONCellData> {
    constructor(props: JSONCellData) {
        super(props);
    }

    getCell() {
        if((null != this.props.displayOverride)) {
            return this.props.displayOverride(this.props.jsonData, this.props.jsonKey, this.props.jsonParentObject, this.props.jsonParentKey, this.props.arrayIndex, this.props.hierarchyIndex, this.props.disabled, this.props.levelCount);
        } else {
            const displayData = ((typeof this.props.jsonData[this.props.jsonKey]) === "object") ? this.props.jsonKey : this.props.displayValue + ": " + this.props.jsonData[this.props.jsonKey];

            if(this.props.title) {
                return <div className={this.props.className} style={this.props.style} title={this.props.title}>{displayData}</div>;
            } else {
                return <div className={this.props.className} style={this.props.style}>{displayData}</div>;
            }
        }
    }

    render() {
        return this.getCell();
    }
}

interface CountData {
    childCount: number,
}

interface ProgressiveExpansionState {
    isExpanding: boolean;
    currentLevel: number;
    totalLevels: number;
    expandedCount: number;
    totalToExpand: number;
    cancelRequested: boolean;
}

interface ReactJSONRowData {
    jsonObject: any,
    jsonParentObject: any,
    jsonKey: string,
    jsonParentKey: string,
    arrayIndex: number,
    id?: string,
    hierarchyIndex?: number,
    rowClass?: string,
    rowStyle?: {},
    sortColumnIndex?: number, // -1 to add to the end
    addSelectColumn?: boolean,
    selectColumnIndex?: number, // -1 to add to the end
    onRowClick?: (jsonObject: any, key: string, parentObject: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean, altKey: boolean) => void,
    onRowRightClick?: (jsonObject: any, key: string, parentObject: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean, altKey: boolean) => void,
    selectColumns?: [],
    css?: string,
    style?: {},
    selectRecordWithRowClick?: boolean,
    displayOverride?: (jsonObject: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, disabled: boolean, levelCount: number) => {},
    displayValue?: string,
    stopPropagationOnClick?: boolean,
    hightlightSelectedRowCSS?: (jsonObject: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number) => string,
    rowAdditionalAttributes?: (jsonObject: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number) => {},
    doHighlightRow?: boolean,
    tabIndex?: number,
    rowReference?: RefObject<any>,
    disabled?: boolean,
    shouldRowUpdate?: (nextRow: any, jsonObject: any, hierarchyIndex: number) => boolean,
    levelCount?: number,
}

class ReactJSONRow extends React.Component<ReactJSONRowData> {
    constructor(props: ReactJSONRowData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.onRowClick = this.onRowClick.bind(this);
        this.onRowRightClick = this.onRowRightClick.bind(this);
    }

    shouldComponentUpdate(nextProps: Readonly<ReactJSONRowData>, nextState: Readonly<{}>, nextContext: any): boolean {
        if(null != this.props.shouldRowUpdate) {
            return this.props.shouldRowUpdate(nextProps.jsonObject, this.props.jsonObject, nextProps.hierarchyIndex);
        } else {
            return nextProps.jsonObject != this.props.jsonObject ||
                nextProps.jsonKey != this.props.jsonKey ||
                nextProps.doHighlightRow != this.props.doHighlightRow ||
                nextProps.disabled != this.props.disabled ||
                nextProps.css != this.props.css ||
                nextProps.style != this.props.style ||
                nextProps.rowClass != this.props.rowClass ||
                nextProps.rowStyle != this.props.rowStyle ||
                nextProps.jsonParentKey != this.props.jsonParentKey ||
                nextProps.arrayIndex != this.props.arrayIndex
                ;
        }
    }

    onRowClick(event: any) {
        if(null != this.props.onRowClick) {
            this.props.onRowClick(this.props.jsonObject, this.props.jsonKey, this.props.jsonParentObject, this.props.jsonParentKey, this.props.arrayIndex, this.props.hierarchyIndex, event.shiftKey, event.ctrlKey, event.altKey);
        }
        if(this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onRowRightClick(event: any) {
        event.preventDefault();

        if(null != this.props.onRowRightClick) {
            this.props.onRowRightClick(this.props.jsonObject, this.props.jsonKey, this.props.jsonParentObject, this.props.jsonParentKey, this.props.arrayIndex, this.props.hierarchyIndex, event.shiftKey, event.ctrlKey, event.altKey);
        }
    }

    render() {
        const rowHighlightClass = (null != this.props.hightlightSelectedRowCSS) ? this.props.hightlightSelectedRowCSS(this.props.jsonObject, this.props.jsonKey, this.props.jsonParentObject, this.props.jsonParentKey, this.props.arrayIndex, this.props.hierarchyIndex) : 'copia_color3_b nowrap';
        const rowClasses = (this.props.doHighlightRow) ? (' ' + rowHighlightClass) : '';
        const rowAdditionalAttributes = (null != this.props.rowAdditionalAttributes) ? this.props.rowAdditionalAttributes(this.props.jsonObject, this.props.jsonKey, this.props.jsonParentObject, this.props.jsonParentKey, this.props.arrayIndex, this.props.hierarchyIndex) : {};

        return <div data-hierarchyIndex={this.props.hierarchyIndex} data-hierarchyLevel={this.props.levelCount} id={this.props.id} ref={this.props.rowReference} style={this.props.style} className={this.props.css + rowClasses} onClick={this.onRowClick} onContextMenu={this.onRowRightClick} {...rowAdditionalAttributes}>
            <ReactJSONCell
                jsonData={this.props.jsonObject}
                jsonParentObject={this.props.jsonParentObject}
                jsonKey={this.props.jsonKey}
                jsonParentKey={this.props.jsonParentKey}
                arrayIndex={this.props.arrayIndex}
                hierarchyIndex={this.props.hierarchyIndex}
                displayValue={this.props.displayValue}
                displayOverride={this.props.displayOverride}
                style={this.props.rowStyle}
                className={this.props.rowClass}
                disabled={this.props.disabled}
                levelCount={this.props.levelCount}
            />
        </div>;
    }
}

// Represents a single visible row in the hierarchy flat map (used for keyboard navigation)
interface HierarchyFlatEntry {
    hierarchyIndex: number;
    obj: any;
    key: string;
    parentObj: any;
    parentKey: string;
    arrayIndex: number;
    isAccordion: boolean;
    isExpanded: boolean;
    // Full ancestor chain: list of accordion obj references from root → direct parent
    // Used to expand collapsed parents when Tab-navigating to a hidden row
    ancestors?: any[];
}

interface ReactJSONListData {
    id?: string,
    style?: {},
    css?: string,
    divContainerCSS?: string,
    divContainerStyle?: {},
    collapsedStyle?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, isFocused?: boolean) => {},
    collapsedCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, isFocused: boolean) => string,
    expandedCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, isFocused: boolean) => string,
    expandedStyle?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, isFocused?: boolean) => {},
    contentStyle?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string) => {},
    contentCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string) => string,
    dataKey: string,
    jsonData: {},
    tabIndex?: null,
    refreshID?: string,
    onRefresh?: () => {},
    expandedID?: string,
    stopPropagationOnClick?: boolean,
    disabled?: boolean,
    disableID?: string,
    rowID?: string,
    hiddenTotalCountID?: string,
    arrowExpandCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string) => string,
    arrowCollapseCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string) => string,
    arrowStyle?:  (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string) => {},
    displayOverride: (rowObj: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, disabled: boolean, levelCount: number) => {},
    hierarchyPagingArrowDisplayOverride: (jsonObject: any, hierarchyIndex: number, pageDown: boolean, disabled: boolean, levelCount: number) => {},
    hightlightSelectedRowCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number) => string,
    rowAdditionalAttributes?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number) => {},
    rowsCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, arrayIndex: number) => string,
    rowsStyle?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, arrayIndex: number) => {},
    cellsCSS?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, arrayIndex: number) => string,
    cellsStyle?: (jsonObject: any, jsonKey: string, parentObj: any, parentKey: string, arrayIndex: number) => {},
    onRowClick?: (jsonObject: any, jsonKey: string, parentObject: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean, altKey: boolean) => boolean,
    onRowRightClick?: (jsonObject: any, jsonKey: string, parentObject: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean, altKey: boolean) => boolean,
    allowExpandAndCollapse?: (jsonObject: any, jsonKey: string, parentObject: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, isExpandingAll: boolean, isCollapsingAll: boolean) => boolean,
    shouldRowUpdate?: (nextRow: any, row: any, rowIndex: number) => boolean,
    initialRowSelected?: string,
    initialRowsSelected?: string[],
    rowKey?: string,
    leftOfArrowContent?: (jsonObject: any, jsonKey: string, parentObj: any, jsonParentKey: string, arrayIndex: number, hierarchyIndex: number, levelCount: number) => any,
    onCollapseExpandAccordion?: (jsonObj: any, rowIndex: number, shiftKey: boolean, ctrlKey: boolean) => boolean,
    canDisplayRow?: (jsonObject: any, jsonKey: string, parentObj: any, jsonParentKey: string, arrayIndex: number) => boolean,
    canDisplayRowType?: (jsonObject: any, jsonKey: string, parentObj: any, jsonParentKey: string, arrayIndex: number) => boolean,
    onScroll?: (jQueryObj: any, scrollTopVal: number) => void,
    listArrayContentInRows?: boolean,
    sortKeys?: (keyA: string, keyB: string, obj: any) => number,
    displayLeafNode?: boolean,
    getJSONData?: (jsonData: any) => void,
    enableKeyboardNavigation?: boolean,  // Enable keyboard navigation with arrow keys
    allowFocusOnRow?: (rowOBJ: any, jsonKey: string, keyPressed: string, hierarchyIndex: number, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,  // Callback to determine if row can receive focus
    isRowAnswered?: (rowOBJ: any, jsonKey: string, hierarchyIndex: number) => boolean,  // Callback to determine if row is already answered (Tab skips answered rows)
    onKeyDown?: (rowOBJ: any, keyPressed: string, hierarchyIndex: number, bShift: boolean, bCTRL: boolean, bALT: boolean) => void,  // Callback when key is pressed
    onKeyUp?: (rowOBJ: any, keyPressed: string, hierarchyIndex: number, bShift: boolean, bCTRL: boolean, bALT: boolean) => void,  // Callback when key is released
    onCustomTabNavigation?: (event: KeyboardEvent, currentHierarchyIndex: number | undefined, isShiftTab: boolean, flatMap: HierarchyFlatEntry[], translatedJSON: any) => boolean | { type: 'focusHierarchyIndex', hierarchyIndex: number, requireEnterable: boolean },  // Custom Tab handler - return true to prevent default, or object to focus specific index
    shouldAllowFocusOnCandidate?: (rowOBJ: any, jsonKey: string, keyPressed: string, hierarchyIndex: number, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,  // Called for each candidate element during navigation - return true to allow focus, false to skip
    focusedElementCSS?: string,  // CSS class to apply to focused elements
    focusFirstElementOnLoad?: boolean,  // Focus first element when component loads
    disableHorizontalScrollOnNavigation?: boolean,
    overrideScrollIntoView?: (row: any, highlightKey: string) => void,
}


interface ReactJSONListState {
    jsonData: {},
    highlightSelectedRow: any,
    disabled: boolean,
    rowCount?: number,
    rowIsDragging: boolean,
    highlightKey: string,
    rowIsClicked: boolean,
    highlightMultipleKeys: string[],
    focusedHierarchyIndex?: number,  // Track which hierarchyIndex should have focus styling
    progressiveExpansion?: ProgressiveExpansionState,  // Track progressive expand all state
    isExpandingAll?: boolean,  // Flag to prevent input clearing during expansion
}

export class ReactJSONHierarchy extends React.Component<ReactJSONListData> {
    totalRowCount: number;
    foundPrevRow: boolean;
    foundCurrentRow: boolean;
    returnNextRow: boolean;
    foundParentRow: boolean;
    listRowRef: RefObject<any>;
    highlightRowRef: RefObject<any>;
    lastSelectedRow: any;
    // Flat map of visible hierarchy rows, rebuilt each render
    private hierarchyFlatMap: HierarchyFlatEntry[] = [];
    // Effective focused hierarchy index for the current render pass
    private effectiveFocusedIndex: number | undefined = undefined;

    private expandAllWorkToken: number = 0;
    private collapseAllWorkToken: number = 0;

    private getNavigationScrollLeft(): number | null {
        if (!this.props.disableHorizontalScrollOnNavigation || !this.listRowRef || !this.listRowRef.current) {
            return null;
        }

        return (this.listRowRef.current as HTMLElement).scrollLeft;
    }

    private restoreNavigationScrollLeft(scrollLeft: number | null) {
        if (scrollLeft === null || !this.listRowRef || !this.listRowRef.current) {
            return;
        }

        (this.listRowRef.current as HTMLElement).scrollLeft = scrollLeft;
    }

    private handleSelectableInputMouseInteraction(target: HTMLElement): boolean {
        if (!target) {
            return false;
        }

        const tagName = target.tagName;

        // Handle TEXTAREA and SELECT - prevent onClick from updating state (which causes blur)
        if (tagName === 'TEXTAREA' || tagName === 'SELECT') {
            return true; // Block onClick from proceeding
        }

        // Handle INPUT elements
        if (tagName === 'INPUT') {
            const input = target as HTMLInputElement;
            const inputType = (input.type || '').toLowerCase();

            // For text inputs, also block to prevent blur
            if (inputType !== 'radio' && inputType !== 'checkbox') {
                return true; // Block onClick from proceeding
            }

            // For radio/checkbox, update hierarchy state
            const shell = input.closest('[id]') as HTMLElement;
            let hierarchyIndex: number | null = null;
            if (shell && shell.id && /^\d+$/.test(shell.id)) {
                hierarchyIndex = parseInt(shell.id, 10);
            }

            if (hierarchyIndex !== null && this.props.enableKeyboardNavigation) {
                if ((this.state as ReactJSONListState).focusedHierarchyIndex !== hierarchyIndex) {
                    this.setState({ focusedHierarchyIndex: hierarchyIndex });
                }
            }

            return true; // Block onClick from proceeding for radio/checkbox too
        }

        return false; // Not an input element, let onClick proceed
    }

    constructor(props: ReactJSONListData) {
        super(props);

        this.listRowRef = React.createRef();
        this.highlightRowRef = React.createRef();
        this.totalRowCount = 0;
        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;

        let canSelectInitialRow = null != props.initialRowSelected && null != this.props.rowKey;
        let localHighlightKey: string = '';
        let highlightMultipleKeys: string[] = [];
        if(canSelectInitialRow) {
            this.lastSelectedRow = props.initialRowSelected;
            localHighlightKey = props.initialRowSelected;
            highlightMultipleKeys = props.initialRowsSelected;
        }

        this.state = {
            jsonData: props.jsonData,
            highlightSelectedRow: null,
            disabled: props.disabled,
            rowIsDragging: false,
            highlightKey: localHighlightKey,
            rowIsClicked: false,
            highlightMultipleKeys: highlightMultipleKeys,
            focusedHierarchyIndex: undefined,
            progressiveExpansion: undefined,
        };

        // Binding is necessary to allow these functions access to the State data
        this.onRefresh = this.onRefresh.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onExpandAll = this.onExpandAll.bind(this);
        this.onCollapseAll = this.onCollapseAll.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.highlightRow = this.highlightRow.bind(this);
        this.onRightClick = this.onRightClick.bind(this);
        this.executeScroll = this.executeScroll.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.getJSONData = this.getJSONData.bind(this);
        this.handleElementFocus = this.handleElementFocus.bind(this);
        this.handleHeaderClick = this.handleHeaderClick.bind(this);
    }

    componentDidMount() {
        // Focus is now set during rendering - no prebuild needed
    }

    componentDidUpdate(prevProps: Readonly<ReactJSONListData>, prevState: Readonly<ReactJSONListState>) {
        // No-op: all state changes driven by event handlers
    }

    // React synthetic focus handler — attached to the container div via onFocus
    handleElementFocus(event: React.FocusEvent<HTMLDivElement>) {
        if (!this.props.enableKeyboardNavigation) return;

        const target = event.target as HTMLElement;

        // Ignore hidden system elements (categoryAllHide)
        if (target.closest && target.closest('.categoryAllHide')) {
            return;
        }

        // For INPUT, TEXTAREA, SELECT: update hierarchy focus but don't interfere with browser focus
        const isInput = target.tagName === 'INPUT';
        const isTextarea = target.tagName === 'TEXTAREA';
        const isSelect = target.tagName === 'SELECT';

        if (isInput || isTextarea || isSelect) {
            // Check if this is a navigation-triggered focus (not user click)
            const isNavigationTriggered = this.listRowRef?.current?.getAttribute('data-navigation-active') === 'true';

            // If this is a direct user click on textarea/editable input (not navigation),
            // DO NOT update state - that causes re-renders which can steal focus
            const inputType = isInput ? ((target as HTMLInputElement).type || '').toLowerCase() : '';
            const isTextEntry = isTextarea || isSelect ||
                               (isInput && inputType !== 'radio' && inputType !== 'checkbox');

            if (!isNavigationTriggered && isTextEntry) {
                // Let browser handle focus naturally - no React interference
                return;
            }

            // For radio/checkbox or navigation-triggered focus, update hierarchy index
            let hierarchyIndex: number | null = null;
            let el: HTMLElement | null = target.parentElement;
            while (el) {
                const shellId = el.id;
                if (shellId && /^\d+$/.test(shellId)) {
                    const idx = parseInt(shellId, 10);
                    if (this.hierarchyFlatMap.some(e => e.hierarchyIndex === idx)) {
                        hierarchyIndex = idx;
                        break;
                    }
                }
                el = el.parentElement;
            }

            if (hierarchyIndex !== null) {
                if ((this.state as ReactJSONListState).focusedHierarchyIndex !== hierarchyIndex) {
                    // Update state without triggering focus changes - the browser already has the right element focused
                    this.setState({ focusedHierarchyIndex: hierarchyIndex });
                }
            }
            return;
        }

        // Header clicks already flow through handleHeaderClick
        const isHeaderElement = target.tagName === 'H3';
        if (isHeaderElement && target.id && /_(\d+)$/.test(target.id)) {
            return;
        }

        // For other elements, find hierarchyIndex and update state
        let hierarchyIndex: number | null = null;

        if (target.tagName === 'H3') {
            const match = target.id ? target.id.match(/_(\d+)$/) : null;
            if (match) {
                hierarchyIndex = parseInt(match[1]);
            }
        } else {
            let el: HTMLElement | null = target.parentElement;
            while (el) {
                const shellId = el.id;
                if (shellId && /^\d+$/.test(shellId)) {
                    const idx = parseInt(shellId);
                    if (this.hierarchyFlatMap.some(e => e.hierarchyIndex === idx)) {
                        hierarchyIndex = idx;
                        break;
                    }
                }
                el = el.parentElement;
            }
        }

        if (hierarchyIndex === null) {
            return;
        }

        const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === hierarchyIndex);
        if (!entry) {
            return;
        }

        if (this.props.allowFocusOnRow) {
            const canFocus = this.props.allowFocusOnRow(entry.obj, entry.key, '', hierarchyIndex, false, false, false);
            if (!canFocus) {
                return;
            }
        }

        if ((this.state as ReactJSONListState).focusedHierarchyIndex !== hierarchyIndex) {
            this.setState({ focusedHierarchyIndex: hierarchyIndex });
        }
    }

    // Called when an accordion header is clicked — updates focus without interfering with expand/collapse
    handleHeaderClick(rowObj: any, rowIndex: number) {
        if (!this.props.enableKeyboardNavigation) return;
        const hierarchyIndex = rowIndex;
        const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === hierarchyIndex);
        if (!entry) return;
        if (this.props.allowFocusOnRow) {
            const canFocus = this.props.allowFocusOnRow(entry.obj, entry.key, '', hierarchyIndex, false, false, false);
            if (!canFocus) return;
        }
        if ((this.state as ReactJSONListState).focusedHierarchyIndex !== hierarchyIndex) {
            this.setState({ focusedHierarchyIndex: hierarchyIndex });
        }
    }


    // Register a visible entry in the flat map during getAccordionRow.
    // Also resolves effectiveFocusedIndex for focusFirstElementOnLoad (state == -1 sentinel).
    private registerFlatMapEntry(hierarchyIndex: number, obj: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, isAccordion: boolean, isExpanded: boolean, visible: boolean = true, ancestors?: any[]) {
        if (!this.props.enableKeyboardNavigation) return;

        // Only add to navigable flat map if this element is currently visible
        if (visible) {
            const entry: HierarchyFlatEntry = { hierarchyIndex, obj, key, parentObj, parentKey, arrayIndex, isAccordion, isExpanded, ancestors: ancestors || [] };
            this.hierarchyFlatMap.push(entry);
        }

        // Set the first focusable element during rendering
        const { focusedHierarchyIndex } = this.state as ReactJSONListState;

        if (visible && this.effectiveFocusedIndex === undefined) {
            // If focusFirstElementOnLoad is true and no focus set yet in state, use first focusable element
            if (this.props.focusFirstElementOnLoad && focusedHierarchyIndex === undefined) {
                if (this.props.allowFocusOnRow) {
                    if (this.props.allowFocusOnRow(obj, key, '', hierarchyIndex, false, false, false)) {
                        this.effectiveFocusedIndex = hierarchyIndex;
                    }
                } else {
                    this.effectiveFocusedIndex = hierarchyIndex;
                }
            }
        }

        // If we have a focusedHierarchyIndex in state, use it for this render
        if (focusedHierarchyIndex !== undefined && this.effectiveFocusedIndex === undefined) {
            if (hierarchyIndex === focusedHierarchyIndex) {
                this.effectiveFocusedIndex = hierarchyIndex;
            }
        }
    }

    // Find the flat map index for a given hierarchyIndex
    private getFlatMapIndexByHierarchyIndex(hierarchyIndex: number): number {
        return this.hierarchyFlatMap.findIndex(e => e.hierarchyIndex === hierarchyIndex);
    }

    private isTextEntryTarget(target: HTMLElement): boolean {
        if (!target) return false;

        const tagName = target.tagName;
        if (tagName === 'TEXTAREA' || tagName === 'SELECT') return true;
        if (target.isContentEditable) return true;
        if (tagName === 'INPUT') {
            const inputType = (((target as HTMLInputElement).type || '').toLowerCase());
            return inputType !== 'radio' && inputType !== 'checkbox' && inputType !== 'button' && inputType !== 'submit' && inputType !== 'reset';
        }

        return false;
    }

    private getNavigationReferenceIndex(direction: 'up' | 'down', preferredHierarchyIndex?: number): number {
        const flatMap = this.hierarchyFlatMap;
        if (flatMap.length === 0) return -1;

        // Always prefer the state's focusedHierarchyIndex if it's valid
        if (preferredHierarchyIndex !== undefined) {
            const preferredIndex = this.getFlatMapIndexByHierarchyIndex(preferredHierarchyIndex);
            if (preferredIndex >= 0) {
                return preferredIndex;
            }
        }

        // Fallback: try to find position from the active element
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement) {
            // First check if the active element itself has a data-hierarchyindex attribute
            const directIndex = activeElement.getAttribute('data-hierarchyindex');
            if (directIndex && /^\d+$/.test(directIndex)) {
                const hierarchyIndex = parseInt(directIndex, 10);
                const flatIndex = flatMap.findIndex(e => e.hierarchyIndex === hierarchyIndex);
                if (flatIndex >= 0) {
                    return flatIndex;
                }
            }

            // Walk up to find a parent shell with numeric ID
            let shell = activeElement.closest('[id]') as HTMLElement;
            while (shell) {
                if (shell.id && /^\d+$/.test(shell.id)) {
                    const hierarchyIndex = parseInt(shell.id, 10);
                    const flatIndex = flatMap.findIndex(e => e.hierarchyIndex === hierarchyIndex);
                    if (flatIndex >= 0) {
                        return flatIndex;
                    }
                }
                shell = shell.parentElement ? shell.parentElement.closest('[id]') as HTMLElement : null;
            }
        }

        return direction === 'down' ? -1 : flatMap.length;
    }

    private activateFocusedSelectableInput(event: any): boolean {
        const target = event.target as HTMLElement;
        const isInput = target && target.tagName === 'INPUT';
        const inputType = isInput ? (((target as HTMLInputElement).type || '').toLowerCase()) : '';
        const isSelectableInput = inputType === 'checkbox' || inputType === 'radio';

        if (isSelectableInput) {
            const inputEl = target as HTMLInputElement;
            if (!inputEl.disabled) {
                event.preventDefault();
                event.stopPropagation();
                inputEl.click();
                inputEl.focus({ preventScroll: true });
                return true;
            }
        }

        const { focusedHierarchyIndex } = this.state as ReactJSONListState;
        if (focusedHierarchyIndex === undefined) {
            return false;
        }

        const selector = 'input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled])';
        const containers: Array<Element | null> = [
            document.getElementById(`${focusedHierarchyIndex}`),
            document.querySelector(`[data-hierarchyindex="${focusedHierarchyIndex}"]`),
            document.querySelector(`h3[id$="_${focusedHierarchyIndex}"]`),
        ];

        for (const container of containers) {
            if (!container) continue;

            let input: HTMLInputElement | null = null;
            if ((container as HTMLElement).matches && (container as HTMLElement).matches(selector)) {
                input = container as HTMLInputElement;
            } else {
                input = container.querySelector(selector) as HTMLInputElement;
            }

            if (input) {
                event.preventDefault();
                event.stopPropagation();
                input.click();
                input.focus({ preventScroll: true });
                return true;
            }
        }

        return false;
    }

    private scrollFocusedElementIntoView(hierarchyIndex: number) {
        requestAnimationFrame(() => {
            const preservedScrollLeft = this.getNavigationScrollLeft();
            const scrollTarget =
                (document.querySelector(`h3[id$="_${hierarchyIndex}"]`) as HTMLElement) ||
                (document.getElementById(`${hierarchyIndex}`) as HTMLElement) ||
                (document.querySelector(`[data-hierarchyindex="${hierarchyIndex}"]`) as HTMLElement);

            if (scrollTarget) {
                scrollTarget.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: this.props.disableHorizontalScrollOnNavigation ? 'nearest' : 'center'
                });
            }

            this.restoreNavigationScrollLeft(preservedScrollLeft);
        });
    }


    private focusHierarchyRow(hierarchyIndex: number) {

        const focusTargets: Array<HTMLElement | null> = [
            document.querySelector(`h3[id$="_${hierarchyIndex}"]`) as HTMLElement,
            document.getElementById(`${hierarchyIndex}`) as HTMLElement,
            document.querySelector(`[data-hierarchyindex="${hierarchyIndex}"]`) as HTMLElement,
        ];

        for (const target of focusTargets) {
            if (target && typeof target.focus === 'function') {

                // Use requestAnimationFrame to ensure DOM is stable
                requestAnimationFrame(() => {
                    target.focus({ preventScroll: true });
                });
                return;
            }
        }
    }

    private focusEnterableForHierarchyIndex(hierarchyIndex: number, depth: number = 0): boolean {

        // Prevent infinite recursion
        if (depth > 5) {
            return false;
        }

        const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === hierarchyIndex);
        if (!entry) {
            return false;
        }

        // If this is a Section or Question header, expand it and find first enterable descendant
        if (entry.key === 'Section' || entry.key === 'Question') {
            const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';

            // Expand if needed
            if (!entry.obj[dataKey]) {
                entry.obj[dataKey] = true;

                // Trigger re-render, then find first descendant using data model
                this.setState({
                    jsonData: (this.state as ReactJSONListState).jsonData,
                    rowCount: -1,
                }, () => {
                    // After expansion, immediately find first descendant in data model
                    // Use requestAnimationFrame to ensure React has completed rendering
                    requestAnimationFrame(() => {
                        const firstDescendantIndex = this.findFirstEnterableDescendantInModel(hierarchyIndex);
                        if (firstDescendantIndex !== null) {
                            // Recursively focus the descendant (which might also be a header that needs expanding)
                            this.focusEnterableForHierarchyIndex(firstDescendantIndex, depth + 1);
                        }
                    });
                });
                return true;
            } else {
                // Already expanded, find first descendant using data model
                const firstDescendantIndex = this.findFirstEnterableDescendantInModel(hierarchyIndex);
                if (firstDescendantIndex !== null) {
                    // Recursively focus the descendant (which might also be a header that needs expanding)
                    this.focusEnterableForHierarchyIndex(firstDescendantIndex, depth + 1);
                }
                return true;
            }
        }

        // For non-headers, find the actual input in this specific row
        const prioritySelectors = [
            'input[type="radio"]:not([disabled]):not(.categoryAllHide)',
            'input[type="checkbox"]:not([disabled]):not(.categoryAllHide)',
            'textarea:not([disabled]):not(.categoryAllHide)',
            'input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([disabled]):not(.categoryAllHide)',
            'select:not([disabled]):not(.categoryAllHide)'
        ];

        const containers: Array<HTMLElement | null> = [
            document.getElementById(`${hierarchyIndex}`) as HTMLElement,
            document.querySelector(`[data-hierarchyindex="${hierarchyIndex}"]`) as HTMLElement,
        ];

        for (const container of containers) {
            if (!container) continue;

            for (const selector of prioritySelectors) {
                const enterables = container.querySelectorAll(selector);

                for (let i = 0; i < enterables.length; i++) {
                    const enterable = enterables[i] as HTMLElement;

                    // Must have an ID and be visible
                    if (!enterable.id) continue;
                    if (enterable.offsetParent === null && enterable.offsetWidth === 0 && enterable.offsetHeight === 0) continue;
                    // Update focusedHierarchyIndex to this row before focusing
                    this.setState({ focusedHierarchyIndex: hierarchyIndex }, () => {
                        // Scroll and focus
                        requestAnimationFrame(() => {
                            enterable.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: this.props.disableHorizontalScrollOnNavigation ? 'nearest' : 'center'
                            });

                            requestAnimationFrame(() => {
                                enterable.focus({ preventScroll: true });
                                this.restoreNavigationScrollLeft(this.getNavigationScrollLeft());
                            });
                        });
                    });

                    return true;
                }
            }
        }

        return false;
    }

    private findFirstEnterableDescendantInModel(parentHierarchyIndex: number): number | null {
        const parentIndex = this.getFlatMapIndexByHierarchyIndex(parentHierarchyIndex);
        const parentEntry = this.hierarchyFlatMap[parentIndex];

        if (parentIndex < 0 || !parentEntry) {
            return null;
        }

        const parentLevel = parentEntry.ancestors ? parentEntry.ancestors.length : 0;

        // Search descendants in the flat map
        for (let i = parentIndex + 1; i < this.hierarchyFlatMap.length; i++) {
            const descendant = this.hierarchyFlatMap[i];
            const descendantLevel = descendant.ancestors ? descendant.ancestors.length : 0;

            // Check if we've left the parent's descendants (same or lower level)
            if (descendantLevel <= parentLevel) {
                break;
            }

            // Section/Question headers need to be expanded recursively
            if (descendant.key === 'Section' || descendant.key === 'Question') {
                // This is a nested header - it will need to be expanded
                // Return it so focusEnterableForHierarchyIndex can expand and recurse
                return descendant.hierarchyIndex;
            }

            // Check if this descendant can have focus
            if (this.props.allowFocusOnRow) {
                const canFocus = this.props.allowFocusOnRow(descendant.obj, descendant.key, '', descendant.hierarchyIndex, false, false, false);
                if (!canFocus) {
                    continue;
                }
            }

            // Check if row has enterable using data model
            if (this.hasEnterableInModelOrDOM(descendant)) {
                return descendant.hierarchyIndex;
            }
        }

        return null;
    }

    private hasEnterableInModelOrDOM(entry: any): boolean {
        // First check the data model for efficiency
        if (this.hasEnterableInModel(entry.obj, entry.key)) {
            return true;
        }

        // Fallback to DOM check for rendered content
        return this.hasVisibleEnterableInDOM(entry.hierarchyIndex);
    }

    private hasEnterableInModel(obj: any, key: string): boolean {
        if (!obj) return false;

        // ShellItem has ChildItems that may contain ResponseFields
        if (key === 'ShellItem' && obj.ChildItems && Array.isArray(obj.ChildItems)) {
            for (const child of obj.ChildItems) {
                if (child.Type === 'ListItemResponseField' || child.Type === 'ResponseField') {
                    return true;
                }
            }
        }

        // Check for common enterable properties
        if (obj.Type === 'ResponseField' || obj.Type === 'ListItemResponseField') {
            return true;
        }

        return false;
    }

    private findAndFocusFirstEnterableDescendant(parentHierarchyIndex: number, depth: number = 0) {

        // Prevent infinite recursion
        if (depth > 10) {
            return;
        }

        // Wait for re-render to complete
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const parentIndex = this.getFlatMapIndexByHierarchyIndex(parentHierarchyIndex);
                const parentEntry = this.hierarchyFlatMap[parentIndex];

                if (parentIndex < 0 || !parentEntry) {
                    return;
                }

                // Search within parent's descendants only
                const parentLevel = parentEntry.ancestors ? parentEntry.ancestors.length : 0;

                for (let i = parentIndex + 1; i < this.hierarchyFlatMap.length; i++) {
                    const descendant = this.hierarchyFlatMap[i];
                    const descendantLevel = descendant.ancestors ? descendant.ancestors.length : 0;

                    // Check if we've left the parent's descendants (same or lower level)
                    if (descendantLevel <= parentLevel) {
                        break;
                    }

                    // Skip Section/Question headers unless they're direct children
                    if (descendant.key === 'Section' || descendant.key === 'Question') {
                        // Check if this is an immediate child of the parent
                        const isImmediateChild = descendantLevel === parentLevel + 1;

                        if (isImmediateChild && this.rowHasEnterableElement(descendant.hierarchyIndex)) {

                            // Expand it if needed
                            const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                            if (!descendant.obj[dataKey]) {
                                descendant.obj[dataKey] = true;
                                this.setState({
                                    jsonData: (this.state as ReactJSONListState).jsonData,
                                    rowCount: -1,
                                }, () => {
                                    // Recursively search within this header
                                    this.findAndFocusFirstEnterableDescendant(descendant.hierarchyIndex, depth + 1);
                                });
                                return;
                            } else {
                                // Already expanded - still need to search within it
                                this.findAndFocusFirstEnterableDescendant(descendant.hierarchyIndex, depth + 1);
                                return;
                            }
                        }

                        // Skip this header and continue searching
                        continue;
                    }

                    // Check if this descendant has an actual visible enterable
                    if (this.hasVisibleEnterableInDOM(descendant.hierarchyIndex)) {

                        // Update state and focus
                        this.setState({
                            focusedHierarchyIndex: descendant.hierarchyIndex
                        }, () => {
                            this.focusEnterableForHierarchyIndex(descendant.hierarchyIndex);
                        });
                        return;
                    }
                }
            });
        });
    }

    private hasVisibleEnterableInDOM(hierarchyIndex: number): boolean {
        const enterableSelector = 'input[type="radio"]:not([disabled]):not(.categoryAllHide), input[type="checkbox"]:not([disabled]):not(.categoryAllHide), textarea:not([disabled]):not(.categoryAllHide), input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([disabled]):not(.categoryAllHide), select:not([disabled]):not(.categoryAllHide)';

        const containers: Array<HTMLElement | null> = [
            document.getElementById(`${hierarchyIndex}`) as HTMLElement,
            document.querySelector(`[data-hierarchyindex="${hierarchyIndex}"]`) as HTMLElement,
        ];

        for (const container of containers) {
            if (!container) continue;

            const enterables = container.querySelectorAll(enterableSelector);
            for (let i = 0; i < enterables.length; i++) {
                const enterable = enterables[i] as HTMLElement;
                // Verify it's visible and has an ID
                if (enterable.id && (enterable.offsetParent !== null || enterable.offsetWidth > 0 || enterable.offsetHeight > 0)) {
                    return true;
                }
            }
        }

        return false;
    }

    private rowHasEnterableElement(hierarchyIndex: number): boolean {

        const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === hierarchyIndex);
        if (!entry) {
            return false;
        }

        // Section and Question headers should NOT be considered enterable themselves
        // They should only be accepted if they have enterable descendants
        if (entry.key === 'Section' || entry.key === 'Question') {
            // Don't check DOM - headers themselves aren't enterable
            // Check data model for descendants
            const hasDescendants = this.hasEnterableDescendantsInModel(entry.obj, entry.key);
            return hasDescendants;
        }

        // For non-headers (ShellItem, ResponseField, etc.), check if visible enterable exists in DOM
        const enterableSelector = 'textarea:not([disabled]):not(.categoryAllHide), input[type="radio"]:not([disabled]):not(.categoryAllHide), input[type="checkbox"]:not([disabled]):not(.categoryAllHide), input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([disabled]):not(.categoryAllHide), select:not([disabled]):not(.categoryAllHide)';

        const containers: Array<HTMLElement | null> = [
            document.getElementById(`${hierarchyIndex}`) as HTMLElement,
            document.querySelector(`[data-hierarchyindex="${hierarchyIndex}"]`) as HTMLElement,
        ];

        for (const container of containers) {
            if (!container) continue;

            // Check for visible, non-hidden enterable elements
            const enterables = container.querySelectorAll(enterableSelector);
            for (let i = 0; i < enterables.length; i++) {
                const enterable = enterables[i] as HTMLElement;
                // Verify the element is actually visible and not in a hidden parent
                if (enterable.offsetParent !== null || enterable.offsetWidth > 0 || enterable.offsetHeight > 0) {
                    return true;
                }
            }
        }

        // If not found in DOM and it's an accordion, check data model
        if (entry.isAccordion) {
            const hasDescendants = this.hasEnterableDescendantsInModel(entry.obj, entry.key);
            return hasDescendants;
        }

        return false;
    }

    private hasEnterableDescendantsInModel(obj: any, key: string): boolean {
        if (!obj || typeof obj !== 'object') return false;

        // For Section/Question objects, check their children
        const target = key ? obj[key] : obj;
        if (!target || typeof target !== 'object') return false;

        // Check if this object or its descendants have ShellItem children with enterable elements
        return this.findEnterableInObject(target);
    }

    private findEnterableInObject(obj: any): boolean {
        if (!obj || typeof obj !== 'object') return false;

        // If this is a ShellItem with shellType that's not DisplayedItem, it's potentially enterable
        if (obj.ShellItem && obj.ShellItem.shellType !== 'DisplayedItem') {
            // Check if it's not disabled
            const isDisabled = obj.ShellItem._disabled === true || obj.ShellItem._parentSelected === false;
            if (!isDisabled) {
                return true;
            }
        }

        // If this is a ResponseField or ListItemResponseField that's not disabled, it's enterable
        if (obj.ResponseField && obj.ResponseField._disabled !== true) {
            return true;
        }
        if (obj.ListItemResponseField && obj.ListItemResponseField._disabled !== true) {
            return true;
        }

        // Recursively check children
        if (Array.isArray(obj)) {
            return obj.some(item => this.findEnterableInObject(item));
        }

        // Check all object properties
        for (const childKey of Object.keys(obj)) {
            const child = obj[childKey];
            if (child && typeof child === 'object') {
                if (this.findEnterableInObject(child)) {
                    return true;
                }
            }
        }

        return false;
    }

    private performFocusEntry(hierarchyIndex: number, requireEnterable: boolean, preservedScrollLeft: number) {

        if (requireEnterable) {
            // Tab mode: focus the actual enterable element
            // Don't update focusedHierarchyIndex yet - let focusEnterableForHierarchyIndex do it
            this.focusEnterableForHierarchyIndex(hierarchyIndex);
        } else {
            // Arrow navigation: focus the H3 header or shell div to show outline
            this.focusHierarchyRow(hierarchyIndex);
            this.scrollFocusedElementIntoView(hierarchyIndex);
        }
        this.restoreNavigationScrollLeft(preservedScrollLeft);

        // Clear the navigation flag after focus operations complete
        // Use triple requestAnimationFrame to ensure all focus operations are done
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (this.listRowRef && this.listRowRef.current) {
                        (this.listRowRef.current as HTMLElement).removeAttribute('data-navigation-active');
                    }
                });
            });
        });
    }

    private moveFocusByNavigationMode(direction: 'up' | 'down', keyPressed: string, shiftKey: boolean, ctrlKey: boolean, requireEnterable: boolean) {
        const flatMap = this.hierarchyFlatMap;
        if (flatMap.length === 0) return;

        // Set a flag on the container to signal that React navigation is active
        if (this.listRowRef && this.listRowRef.current) {
            (this.listRowRef.current as HTMLElement).setAttribute('data-navigation-active', 'true');
        }

        const preservedScrollLeft = this.getNavigationScrollLeft();
        const currentFlatIndex = this.getNavigationReferenceIndex(direction, (this.state as ReactJSONListState).focusedHierarchyIndex);
        const step = direction === 'down' ? 1 : -1;
        let candidate = currentFlatIndex + step;

        while (candidate >= 0 && candidate < flatMap.length) {
            const entry = flatMap[candidate];

            // Use shouldAllowFocusOnCandidate if provided (gives test.jsp fine-grained control)
            if (this.props.shouldAllowFocusOnCandidate) {
                const shouldAllow = this.props.shouldAllowFocusOnCandidate(entry.obj, entry.key, keyPressed, entry.hierarchyIndex, shiftKey, ctrlKey, false);

                if (!shouldAllow) {
                    candidate += step;
                    continue;
                }
            } else if (this.props.allowFocusOnRow) {
                // Fallback to old callback
                const canFocus = this.props.allowFocusOnRow(entry.obj, entry.key, keyPressed, entry.hierarchyIndex, shiftKey, ctrlKey, false);
                if (!canFocus) {
                    candidate += step;
                    continue;
                }
            }

            // For Tab navigation, verify the row actually has an enterable element
            if (requireEnterable) {
                const hasEnterable = this.rowHasEnterableElement(entry.hierarchyIndex);
                if (!hasEnterable) {
                    candidate += step;
                    continue;
                }
            }

            const focusEntryCallback = () => {
                this.performFocusEntry(entry.hierarchyIndex, requireEnterable, preservedScrollLeft);
            };

            if (entry.ancestors && entry.ancestors.length > 0) {
                const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                let needsUpdate = false;
                entry.ancestors.forEach((ancestor) => {
                    if (ancestor && !ancestor[dataKey]) {
                        ancestor[dataKey] = true;
                        needsUpdate = true;
                    }
                });

                // For Tab navigation: don't update focusedHierarchyIndex here - let the focus logic do it
                // For Arrow navigation: update focusedHierarchyIndex to show the outline
                this.setState({
                    jsonData: (this.state as ReactJSONListState).jsonData,
                    focusedHierarchyIndex: requireEnterable ? (this.state as ReactJSONListState).focusedHierarchyIndex : entry.hierarchyIndex,
                    rowCount: needsUpdate ? -1 : (this.state as ReactJSONListState).rowCount,
                }, focusEntryCallback);
            } else {
                // For Tab navigation: don't update focusedHierarchyIndex here - let the focus logic do it
                // For Arrow navigation: update focusedHierarchyIndex
                if (requireEnterable) {
                    // Don't update state, just call the focus logic directly
                    focusEntryCallback();
                } else {
                    this.setState({
                        focusedHierarchyIndex: entry.hierarchyIndex
                    }, focusEntryCallback);
                }
            }

            if (this.props.onKeyDown) {
                this.props.onKeyDown(entry.obj, keyPressed, entry.hierarchyIndex, shiftKey, ctrlKey, false);
            }
            return;
        }

        // Clear navigation flag if no candidate found
        if (this.listRowRef && this.listRowRef.current) {
            (this.listRowRef.current as HTMLElement).removeAttribute('data-navigation-active');
        }

    }

    private moveFocusInFlatMap(direction: 'up' | 'down', keyPressed: string, shiftKey: boolean, ctrlKey: boolean) {
        this.moveFocusByNavigationMode(direction, keyPressed, shiftKey, ctrlKey, false);
    }

    private moveTabFocus(direction: 'up' | 'down', shiftKey: boolean, ctrlKey: boolean) {
        this.moveFocusByNavigationMode(direction, shiftKey ? 'ShiftTab' : 'Tab', shiftKey, ctrlKey, true);
    }

    private tabToNextFocusable(reverse: boolean) {
        this.moveTabFocus(reverse ? 'up' : 'down', reverse, false);
    }

    // Update state from getDerivedStateFromProps
    static getDerivedStateFromProps(props: ReactJSONListData, state: ReactJSONListState): Partial<ReactJSONListState> | null {
        if ((null != props.initialRowSelected || null != props.initialRowsSelected) && null != props.rowKey) {
            return {
                jsonData: props.jsonData,
                highlightKey: props.initialRowSelected,
                highlightSelectedRow: null as any,
                highlightMultipleKeys: props.initialRowsSelected,
                // Preserve focusedHierarchyIndex — do not reset it on prop updates
            };
        }
        return {
            jsonData: props.jsonData,
            highlightSelectedRow: null as any,
            // Preserve focusedHierarchyIndex — do not reset it on prop updates
        };
    }

    executeScroll() {
        if(null != this.props.overrideScrollIntoView) {
            this.props.overrideScrollIntoView(this.highlightRowRef.current, (this.state as ReactJSONListState).highlightKey);
        } else {
            // Scroll the highlighted selected row into view
            if(null != this.highlightRowRef.current && null != (this.state as ReactJSONListState).highlightKey && this.props.enableKeyboardNavigation) {
                this.highlightRowRef.current.scrollIntoView({block: "center", inline: "center"});
            }
        }
    }

    getJSONData() {
        if(null != this.props.getJSONData) {
            this.props.getJSONData((this.state as ReactJSONListState).jsonData);
        }
    }
    getRowDisplay(obj: any, keyParam: string, parentOBJ: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, levelCount: number, doHighlight: boolean) {

        let cellClass = "";
        if(null != this.props.cellsCSS) {
            cellClass = this.props.cellsCSS(obj, keyParam, parentOBJ, parentKey, arrayIndex);
        }

        let cellStyle = {};
        if(null != this.props.cellsStyle) {
            cellStyle = this.props.cellsStyle(obj, keyParam, parentOBJ, parentKey, arrayIndex);
        }

        if(typeof obj == "string" || typeof obj == "number" || typeof obj == "boolean") {
            let rowClass = "";
            if(null != this.props.rowsCSS) {
                rowClass = this.props.rowsCSS(obj, keyParam, parentOBJ, parentKey, arrayIndex);
            }

            let rowStyle = {};
            if(null != this.props.rowsStyle) {
                rowStyle = this.props.rowsStyle(obj, keyParam, parentOBJ, parentKey, arrayIndex);
            }

            return <ReactJSONRow
                id={((this.props.rowID.length > 0) ? this.props.rowID + '__' + keyParam + '_' + hierarchyIndex : this.props.id + '__' + keyParam + '_row_' + hierarchyIndex)}
                doHighlightRow={doHighlight}
                hightlightSelectedRowCSS={this.props.hightlightSelectedRowCSS}
                rowAdditionalAttributes={this.props.rowAdditionalAttributes}
                jsonObject={obj}
                jsonParentObject={parentOBJ}
                jsonKey={keyParam}
                jsonParentKey={parentKey}
                arrayIndex={arrayIndex}
                css={rowClass}
                style={rowStyle}
                hierarchyIndex={hierarchyIndex}
                displayValue={obj + ''}
                displayOverride={this.props.displayOverride}
                onRowClick={this.onClick}
                onRowRightClick={this.onRightClick}
                stopPropagationOnClick={this.props.stopPropagationOnClick}
                rowReference={((doHighlight) ? this.highlightRowRef : null)}
                disabled={(this.state as ReactJSONListState).disabled}
                shouldRowUpdate={this.props.shouldRowUpdate}
                levelCount={levelCount}
                rowClass={cellClass}
                rowStyle={cellStyle}
            />;
        } else {
            obj.hierarchyIndex = hierarchyIndex;

            let rowClass = "";
            if(null != obj.css && 'undefined' != obj.css) {
                rowClass = obj.css;
            } else if(null != this.props.rowsCSS) {
                rowClass = this.props.rowsCSS(obj, keyParam, parentOBJ, parentKey, arrayIndex);
            }

            let rowStyle = {};
            if(null != obj.style && 'undefined' != obj.style) {
                rowStyle = obj.style;
            } else if(null != this.props.rowsStyle) {
                rowStyle = this.props.rowsStyle(obj, keyParam, parentOBJ, parentKey, arrayIndex);
            }

            return <ReactJSONRow
                id={(null != obj.id) ? obj.id : ((this.props.rowID.length > 0) ? this.props.rowID + '_' + hierarchyIndex: this.props.id + '_row_' + hierarchyIndex)}
                doHighlightRow={doHighlight}
                hightlightSelectedRowCSS={this.props.hightlightSelectedRowCSS}
                rowAdditionalAttributes={this.props.rowAdditionalAttributes}
                jsonObject={obj}
                jsonParentObject={parentOBJ}
                jsonKey={keyParam}
                jsonParentKey={parentKey}
                arrayIndex={arrayIndex}
                css={rowClass}
                style={rowStyle}
                hierarchyIndex={hierarchyIndex}
                displayValue={keyParam}
                displayOverride={this.props.displayOverride}
                onRowClick={this.onClick}
                onRowRightClick={this.onRightClick}
                stopPropagationOnClick={this.props.stopPropagationOnClick}
                rowReference={((doHighlight) ? this.highlightRowRef : null)}
                disabled={(this.state as ReactJSONListState).disabled}
                shouldRowUpdate={this.props.shouldRowUpdate}
                levelCount={levelCount}
                rowClass={cellClass}
                rowStyle={cellStyle}
            />;
        }
    }

    getRowContent(obj: any, parentObj: any, parentKey: string, countData: CountData, levelCount: number, visible: boolean = true, ancestors: any[] = []):any {
        const returnArray = [];
        if (Array.isArray(obj)) {
            (obj as any[]).map((subRow, subIndex) => {
                returnArray.push(<React.Fragment key={`row-${subIndex}`}>{this.getAccordionRow(subRow, parentObj, parentKey, subIndex, countData, levelCount, visible, ancestors)}</React.Fragment>);
            });
        } else if (typeof obj === "object") {
            returnArray.push(this.getAccordionRow(obj, parentObj, parentKey, -1, countData, levelCount, visible, ancestors));
        } else if(typeof obj === "string" || typeof obj == "number" || typeof obj == "boolean") {
            returnArray.push(this.getAccordionRow(obj, parentObj, parentKey, -1, countData, levelCount, visible, ancestors));
        }
        return returnArray;
    }

    getAccordionRow(obj: any, parentOBJ: any, parentKey: string, arrayIndex: number, countData: CountData, levelCount: number, visible: boolean = true, ancestors: any[] = []): any {
        const returnArray = [];

        if(obj != null) {
            if (Array.isArray(obj)) {
                obj.forEach((item : any, index: number) => {
                    returnArray.push(this.getAccordionRow(item, parentOBJ, parentKey, index, countData, levelCount, visible, ancestors));
                });
            } else if (typeof obj === "object") {
                for (const key of Object.keys(obj).sort((a, b) => {
                    if (null != this.props.sortKeys) {
                        return this.props.sortKeys(a, b, obj);
                    } return 0;})) {

                    const hierarchyIndex = this.totalRowCount;
                    this.totalRowCount++;

                    const newID = this.props.id + '_' + hierarchyIndex;

                    let newExpandedID = "";
                    if (null != this.props.rowKey && null != obj[this.props.rowKey]) {
                        newExpandedID = this.props.expandedID + '_' + obj[this.props.rowKey];
                    } else {
                        newExpandedID = this.props.expandedID + '_' + hierarchyIndex;
                    }

                    if (null != this.props.allowExpandAndCollapse) {
                        obj.allowExpandAndCollapse = this.props.allowExpandAndCollapse(obj, key, parentOBJ, parentKey, arrayIndex, hierarchyIndex, false, false);
                    } else if (null != obj) {
                        obj.allowExpandAndCollapse = true;
                    }

                    let rowCSS = '';
                    if ((this.state as ReactJSONListState).rowIsDragging && (this.state as ReactJSONListState).highlightSelectedRow == obj) {
                        rowCSS = 'react-drag';
                    }

                    let doHighlight = false;

                    const canDisplayRowType = (null != this.props.canDisplayRowType) ? this.props.canDisplayRowType(obj, key, parentOBJ, parentKey, arrayIndex) : true;

                    // Build the ancestor list for children of this row
                    const childAncestors = [...ancestors, obj];

                    if(canDisplayRowType)
                    {
                        if(Array.isArray(obj[key])) {
                            if(this.props.listArrayContentInRows) {
                                obj[key].forEach((subItem : any, subIndex: number) => {

                                    const canDisplayRow = (null != this.props.canDisplayRow) ? this.props.canDisplayRow({[key]: subItem}, key, parentOBJ, parentKey, subIndex) : true;
                                    if(canDisplayRow)
                                    {
                                    // Register in flat map (accordion with array children)
                                    const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                                    const isExpandedNow = !!(subItem && subItem[dataKey]);
                                    // Children are visible only if parent accordion is expanded
                                    const childrenVisible = visible && isExpandedNow;
                                    this.registerFlatMapEntry(hierarchyIndex, obj, key, parentOBJ, parentKey, subIndex, true, isExpandedNow, visible, ancestors);

                                    const isFocused = this.props.enableKeyboardNavigation && this.effectiveFocusedIndex === hierarchyIndex;

                                    // Pass isFocused as 5th parameter to style functions so JSP can control focus styling
                                    const baseExpandedStyle = (null != this.props.expandedStyle) ? this.props.expandedStyle(obj, key, parentOBJ, parentKey, isFocused) : {};
                                    const baseCollapsedStyle = (null != this.props.collapsedStyle) ? this.props.collapsedStyle(obj, key, parentOBJ, parentKey, isFocused) : {};

                                    const setProps = {
                                        id: newID,
                                        shellID: hierarchyIndex + '',
                                        tabIndex: (this.props.enableKeyboardNavigation) ? 0 : this.props.tabIndex,
                                        text: this.getRowDisplay(obj, key, parentOBJ, parentKey, subIndex, hierarchyIndex, levelCount, doHighlight),
                                        content: this.getRowContent(subItem, parentOBJ, key, countData, levelCount + 1, childrenVisible, childAncestors),
                                        collapsedStyle: baseCollapsedStyle,
                                        collapsedCSS: this.props.collapsedCSS(obj[key], key, parentOBJ, parentKey, isFocused),
                                        css: rowCSS,
                                        style: {},
                                        expandedCSS: this.props.expandedCSS(obj[key], key, parentOBJ, parentKey, isFocused),
                                        expandedStyle: baseExpandedStyle,
                                        contentStyle: (null != this.props.contentStyle) ? this.props.contentStyle(obj, key, parentOBJ, parentKey) : {
                                            marginTop: '0px',
                                            paddingLeft: '16px',
                                            fontWeight: "normal"
                                        },
                                        contentCSS: this.props.contentCSS(obj[key], key, parentOBJ, parentKey),
                                        dataKey: this.props.dataKey,
                                        row: subItem,
                                        rowIndex: hierarchyIndex,
                                        onClick: this.onClick,
                                        onHeaderClick: this.props.enableKeyboardNavigation ? this.handleHeaderClick : null,
                                        onRefresh: this.props.onRefresh,
                                        expandedID: newExpandedID,
                                        stopPropagationOnClick: this.props.stopPropagationOnClick,
                                        disableID: this.props.disableID + '_' + hierarchyIndex,
                                        disabled: (this.state as ReactJSONListState).disabled,
                                        arrowExpandCSS: this.props.arrowExpandCSS(obj, key, parentOBJ, parentKey),
                                        arrowCollapseCSS: this.props.arrowCollapseCSS(obj, key, parentOBJ, parentKey),
                                        arrowStyle: (null != this.props.arrowStyle) ? this.props.arrowStyle(obj, key, parentOBJ, parentKey) : {
                                            width: "16px",
                                            marginTop: "1px"
                                        },
                                        allowExpandAndCollapse: (null != obj.allowExpandAndCollapse) ? obj.allowExpandAndCollapse : true,
                                        leftOfArrowJSONHierarchyContent: (null != this.props.leftOfArrowContent) ? this.props.leftOfArrowContent(obj, key, parentOBJ, parentKey, subIndex, hierarchyIndex, levelCount) : null,
                                        doHighlight: doHighlight,
                                        onCollapseExpandAccordion: this.props.onCollapseExpandAccordion,
                                    };
                                        returnArray.push(getReactAccordion(setProps));
                                    }
                                });
                            } else {
                                const canDisplayRow = (null != this.props.canDisplayRow) ? this.props.canDisplayRow(obj, key, parentOBJ, parentKey, arrayIndex) : true;
                                if(canDisplayRow)
                                {
                                    // Register in flat map
                                    const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                                    const isExpandedNow = !!(obj[dataKey]);
                                    const childrenVisible = visible && isExpandedNow;
                                    this.registerFlatMapEntry(hierarchyIndex, obj, key, parentOBJ, parentKey, arrayIndex, true, isExpandedNow, visible, ancestors);

                                    const isFocused = this.props.enableKeyboardNavigation && this.effectiveFocusedIndex === hierarchyIndex;
                                    const baseExpandedStyle = (null != this.props.expandedStyle) ? this.props.expandedStyle(obj, key, parentOBJ, parentKey, isFocused) : {};
                                    const baseCollapsedStyle = (null != this.props.collapsedStyle) ? this.props.collapsedStyle(obj, key, parentOBJ, parentKey, isFocused) : {};

                                    const setProps = {
                                        id: newID,
                                        shellID: hierarchyIndex + '',
                                        tabIndex: (this.props.enableKeyboardNavigation) ? 0 : this.props.tabIndex,
                                        text: this.getRowDisplay(obj, key, parentOBJ, parentKey, arrayIndex, hierarchyIndex, levelCount, doHighlight),
                                        content: this.getRowContent(obj[key], obj, key, countData, levelCount + 1, childrenVisible, childAncestors),
                                        collapsedStyle: baseCollapsedStyle,
                                        collapsedCSS: this.props.collapsedCSS(obj, key, parentOBJ, parentKey, isFocused),
                                        css: rowCSS,
                                        expandedCSS: this.props.expandedCSS(obj, key, parentOBJ, parentKey, isFocused),
                                        expandedStyle: baseExpandedStyle,
                                        contentStyle: (null != this.props.contentStyle) ? this.props.contentStyle(obj, key, parentOBJ, parentKey) : {
                                            marginTop: '0px',
                                            paddingLeft: '16px',
                                            fontWeight: "normal"
                                        },
                                        contentCSS: this.props.contentCSS(obj[key], key, parentOBJ, parentKey),
                                        dataKey: this.props.dataKey,
                                        row: obj,
                                        rowIndex: hierarchyIndex,
                                        onClick: this.onClick,
                                        onHeaderClick: this.props.enableKeyboardNavigation ? this.handleHeaderClick : null,
                                        onRefresh: this.props.onRefresh,
                                        expandedID: newExpandedID,
                                        stopPropagationOnClick: this.props.stopPropagationOnClick,
                                        disableID: this.props.disableID + '_' + hierarchyIndex,
                                        disabled: (this.state as ReactJSONListState).disabled,
                                        arrowExpandCSS: this.props.arrowExpandCSS(obj, key, parentOBJ, parentKey),
                                        arrowCollapseCSS: this.props.arrowCollapseCSS(obj, key, parentOBJ, parentKey),
                                        arrowStyle: (null != this.props.arrowStyle) ? this.props.arrowStyle(obj, key, parentOBJ, parentKey) : {
                                            width: "16px",
                                            marginTop: "1px"
                                        },
                                        allowExpandAndCollapse: (null != obj.allowExpandAndCollapse) ? obj.allowExpandAndCollapse : true,
                                        leftOfArrowJSONHierarchyContent: (null != this.props.leftOfArrowContent) ? this.props.leftOfArrowContent(obj, key, parentOBJ, parentKey, arrayIndex, hierarchyIndex, levelCount) : null,
                                        doHighlight: doHighlight,
                                        onCollapseExpandAccordion: this.props.onCollapseExpandAccordion,
                                        style: {},
                                    };
                                    returnArray.push(getReactAccordion(setProps));
                                }
                            }
                        } else if(typeof obj[key] === "object") {
                            const canDisplayRow = (null != this.props.canDisplayRow) ? this.props.canDisplayRow(obj, key, parentOBJ, parentKey, arrayIndex) : true;
                            if(canDisplayRow)
                            {
                                // Register in flat map
                                const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                                const isExpandedNow = !!(obj[dataKey]);
                                const childrenVisible = visible && isExpandedNow;
                                this.registerFlatMapEntry(hierarchyIndex, obj, key, parentOBJ, parentKey, arrayIndex, true, isExpandedNow, visible, ancestors);

                                // isFocused: use effectiveFocusedIndex
                                const isFocused = this.props.enableKeyboardNavigation && this.effectiveFocusedIndex === hierarchyIndex;

                                // Pass isFocused as 5th parameter to style functions so JSP can control focus styling
                                const baseExpandedStyle = (null != this.props.expandedStyle) ? this.props.expandedStyle(obj, key, parentOBJ, parentKey, isFocused) : {};
                                const baseCollapsedStyle = (null != this.props.collapsedStyle) ? this.props.collapsedStyle(obj, key, parentOBJ, parentKey, isFocused) : {};

                                const setProps = {
                                    id: newID,
                                    shellID: hierarchyIndex + '',
                                    tabIndex: (this.props.enableKeyboardNavigation) ? 0 : this.props.tabIndex,
                                    text: this.getRowDisplay(obj, key, parentOBJ, parentKey, arrayIndex, hierarchyIndex, levelCount, doHighlight),
                                    content: this.getRowContent(obj[key], obj, key, countData, levelCount + 1, childrenVisible, childAncestors),
                                    collapsedStyle: baseCollapsedStyle,
                                    collapsedCSS: this.props.collapsedCSS(obj, key, parentOBJ, parentKey, isFocused),
                                    css: rowCSS,
                                    expandedCSS: this.props.expandedCSS(obj, key, parentOBJ, parentKey, isFocused),
                                    expandedStyle: baseExpandedStyle,
                                    contentStyle: (null != this.props.contentStyle) ? this.props.contentStyle(obj, key, parentOBJ, parentKey) : {
                                        marginTop: '0px',
                                        paddingLeft: '16px',
                                        fontWeight: "normal"
                                    },
                                    contentCSS: this.props.contentCSS(obj[key], key, parentOBJ, parentKey),
                                    dataKey: this.props.dataKey,
                                    row: obj,
                                    rowIndex: hierarchyIndex,
                                    onClick: this.onClick,
                                    onHeaderClick: this.props.enableKeyboardNavigation ? this.handleHeaderClick : null,
                                    onRefresh: this.props.onRefresh,
                                    expandedID: newExpandedID,
                                    stopPropagationOnClick: this.props.stopPropagationOnClick,
                                    disableID: this.props.disableID + '_' + hierarchyIndex,
                                    disabled: (this.state as ReactJSONListState).disabled,
                                    arrowExpandCSS: this.props.arrowExpandCSS(obj, key, parentOBJ, parentKey),
                                    arrowCollapseCSS: this.props.arrowCollapseCSS(obj, key, parentOBJ, parentKey),
                                    arrowStyle: (null != this.props.arrowStyle) ? this.props.arrowStyle(obj, key, parentOBJ, parentKey) : {
                                        width: "16px",
                                        marginTop: "1px"
                                    },
                                    allowExpandAndCollapse: (null != obj.allowExpandAndCollapse) ? obj.allowExpandAndCollapse : true,
                                    leftOfArrowJSONHierarchyContent: (null != this.props.leftOfArrowContent) ? this.props.leftOfArrowContent(obj, key, parentOBJ, parentKey, arrayIndex, hierarchyIndex, levelCount) : null,
                                    doHighlight: doHighlight,
                                    onCollapseExpandAccordion: this.props.onCollapseExpandAccordion
                                };
                                returnArray.push(getReactAccordion(setProps));
                            }
                        } else {
                            const canDisplayRow = (null != this.props.canDisplayRow) ? this.props.canDisplayRow(obj, key, parentOBJ, parentKey, arrayIndex) : true;
                            if(canDisplayRow)
                            {
                                // Register leaf in flat map — only add to visibleFlatMap if visible
                                this.registerFlatMapEntry(hierarchyIndex, obj, key, parentOBJ, parentKey, arrayIndex, false, false, visible, ancestors);
                                returnArray.push(this.getRowDisplay(obj, key, parentOBJ, parentKey, arrayIndex, hierarchyIndex, levelCount, doHighlight));
                            }
                        }
                    } else {
                        returnArray.push(this.getAccordionRow(obj[key] as any, obj, key, -1, countData, levelCount, visible, childAncestors));
                    }

                }
            } else if(typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean") {
                const hierarchyIndex = this.totalRowCount;
                this.totalRowCount++;

                let doHighlight = false;

                const displayLeafNode = (null != this.props.displayLeafNode) ? this.props.displayLeafNode : true;
                if(displayLeafNode) {
                    const canDisplayRow = (null != this.props.canDisplayRow) ? this.props.canDisplayRow(obj, obj + "", parentOBJ, parentKey, arrayIndex) : true;

                    if(canDisplayRow) {
                        // Register leaf node in flat map
                        this.registerFlatMapEntry(hierarchyIndex, obj, obj + "", parentOBJ, parentKey, arrayIndex, false, false, true, ancestors);
                        returnArray.push(this.getRowDisplay(obj, '', parentOBJ, parentKey, arrayIndex, hierarchyIndex, levelCount, doHighlight));
                    }
                }
            }
        }

        return returnArray;
    }


    getTotal(obj: any) {
        let count = 0;
        if(obj != null) {
            if (Array.isArray(obj)) {
                obj.forEach((item) => {
                    count = count + this.getTotal(item);
                });
            } else if (typeof obj === "object") {
                count = count + 1;
                Object.values(obj).forEach((item) => {
                    count = count + this.getTotal(item);
                });
            } else if (typeof obj === "string" || typeof obj == "number" || typeof obj == "boolean") {
                count = count + 1;
            }
        }
        return count;
    }

    highlightRow(event: any) {
        const localHighlightKey = $(event.currentTarget).val() + "";
        if(localHighlightKey === "") {
            return;
        }

        // Only proceed if navigation is enabled
        if (!this.props.enableKeyboardNavigation) {
            return;
        }

        // Find the hierarchyIndex that matches this rowKey
        if (!this.props.rowKey) {
            return;
        }

        const targetEntry = this.hierarchyFlatMap.find(entry => {
            return entry.obj && entry.obj[this.props.rowKey] === localHighlightKey;
        });

        if (!targetEntry) {
            return;
        }

        const hierarchyIndex = targetEntry.hierarchyIndex;

        // Check if we can focus on this row
        if (this.props.allowFocusOnRow) {
            const canFocus = this.props.allowFocusOnRow(targetEntry.obj, targetEntry.key, '', hierarchyIndex, false, false, false);
            if (!canFocus) {
                return;
            }
        }

        // Expand all ancestors if needed
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
        let needsExpansion = false;

        if (targetEntry.ancestors && targetEntry.ancestors.length > 0) {
            targetEntry.ancestors.forEach(ancestor => {
                if (ancestor && !ancestor[dataKey]) {
                    ancestor[dataKey] = true;
                    needsExpansion = true;
                }
            });
        }

        const focusCallback = () => {
            // Use focusEnterableForHierarchyIndex to focus on enterable child if exists, otherwise the header
            this.focusEnterableForHierarchyIndex(hierarchyIndex);
            this.scrollFocusedElementIntoView(hierarchyIndex);
        };

        if (needsExpansion) {
            this.setState({
                jsonData: (this.state as ReactJSONListState).jsonData,
                focusedHierarchyIndex: hierarchyIndex,
                rowCount: -1,
            }, focusCallback);
        } else {
            this.setState({
                focusedHierarchyIndex: hierarchyIndex,
            }, focusCallback);
        }
    }

    onScroll(event: React.UIEvent<HTMLDivElement, UIEvent>) {
        const target = event.target as HTMLElement;
        const scrollTopVal = target.scrollTop;
        if (null != this.props.onScroll) {
            this.props.onScroll(this.listRowRef.current, scrollTopVal);
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }
        this.totalRowCount = 0;
        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;

        this.setState(() => ({
            jsonData: (this.state as ReactJSONListState).jsonData,
            rowCount: -1
        }));
    }

    onRightClick(obj: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean, altKey: boolean) {
        if(null != this.props.onRowRightClick) {
            this.props.onRowRightClick(obj, key, parentObj, parentKey, arrayIndex, hierarchyIndex, shiftKey, ctrlKey, altKey);
        }
    }

    onClick(obj: any, key: string, parentObj: any, parentKey: string, arrayIndex: number, hierarchyIndex: number, shiftKey: boolean, ctrlKey: boolean, altKey: boolean) {
        const target = ((window as any).event && (window as any).event.target) ? (window as any).event.target as HTMLElement : null;
        if (target && this.handleSelectableInputMouseInteraction(target)) {
            return true;
        }

        const isCalledFromAccordion = typeof key === 'boolean';
        const resolvedHierarchyIndex = isCalledFromAccordion ? (parentKey as any as number) : hierarchyIndex;
        const resolvedShiftKey = isCalledFromAccordion ? (key as any as boolean) : shiftKey;
        const resolvedCtrlKey = isCalledFromAccordion ? (parentObj as any as boolean) : ctrlKey;

        if (this.props.enableKeyboardNavigation && resolvedHierarchyIndex >= 0) {
            const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === resolvedHierarchyIndex);
            if (entry) {
                const canFocus = this.props.allowFocusOnRow
                    ? this.props.allowFocusOnRow(entry.obj, entry.key, '', resolvedHierarchyIndex, resolvedShiftKey, resolvedCtrlKey, false)
                    : true;
                if (canFocus && (this.state as ReactJSONListState).focusedHierarchyIndex !== resolvedHierarchyIndex) {
                    this.setState({ focusedHierarchyIndex: resolvedHierarchyIndex });
                }
            }
        }
        if(null != this.props.onRowClick) {
            return this.props.onRowClick(obj, key as any, parentObj, parentKey, arrayIndex, resolvedHierarchyIndex, resolvedShiftKey, resolvedCtrlKey, altKey || false);
        } else {
            const dataKey = (null != this.props.dataKey) ? this.props.dataKey : "isExpanded";
            const isExpanded = null != obj[dataKey] && obj[dataKey];
            return !isExpanded;
        }
    }

    setExpandOrCollapseForForm(data: any, isExpanding: boolean, dataKey: string) {
        if (Array.isArray(data)) {
            data.forEach((item) => {
                this.setExpandOrCollapseForForm(item, isExpanding, dataKey);
            });
        } else if (typeof data === "object" && data !== null) {
            if (null != this.props.allowExpandAndCollapse) {
                if(isExpanding) {
                    if(this.props.allowExpandAndCollapse(data, '', null, '', -1, -1, true, false)) {
                        data[dataKey] = isExpanding;
                    }
                } else {
                    if(this.props.allowExpandAndCollapse(data, '', null, '', -1, -1, false, true)) {
                        data[dataKey] = isExpanding;
                    }
                }
            } else {
                data[dataKey] = isExpanding;
            }
            Object.values(data).forEach((value: any) => {
                if (typeof value === "object" && value !== null) {
                    this.setExpandOrCollapseForForm(value, isExpanding, dataKey);
                }
            });
        }
    }

    onExpandAll(_event: any) {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';

        this.expandAllWorkToken++;
        this.collapseAllWorkToken++;

        // Expand all immediately without chunking
        this.setExpandOrCollapseForForm((this.state as ReactJSONListState).jsonData, true, dataKey);

        this.setState({
            jsonData: (this.state as ReactJSONListState).jsonData,
            rowCount: -1,
            isExpandingAll: false
        });
    }

    onCollapseAll(_event: any) {
        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';

        this.expandAllWorkToken++;
        this.collapseAllWorkToken++;
        this.setExpandOrCollapseForForm((this.state as ReactJSONListState).jsonData, false, dataKey);

        this.setState({
            jsonData: (this.state as ReactJSONListState).jsonData,
            rowCount: -1,
            isExpandingAll: false,
            progressiveExpansion: undefined,
        });
    }

    onKeyDown(event: any) {
        if (!this.props.enableKeyboardNavigation) return;

        const keyUp = event.key === 'ArrowUp';
        const keyDown = event.key === 'ArrowDown';
        const keyLeft = event.key === 'ArrowLeft';
        const keyRight = event.key === 'ArrowRight';
        const keyEnter = event.key === 'Enter';
        const keySpace = event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space';
        const keyTab = event.key === 'Tab';

        const target = event.target as HTMLElement;
        const isTextarea = target.tagName === 'TEXTAREA';
        const isInput = target.tagName === 'INPUT';
        const isSelect = target.tagName === 'SELECT';
        const isContentEditable = !!target.isContentEditable;
        const inputType = isInput ? (((target as HTMLInputElement).type || '').toLowerCase()) : '';
        const isSelectableInput = inputType === 'radio' || inputType === 'checkbox';
        const isEditableInput = isTextarea || isSelect || isContentEditable || (isInput && !isSelectableInput);

        if ((keyEnter || keySpace) && isEditableInput) {
            return;
        }

        if ((keyUp || keyDown) && isEditableInput) {
            return;
        }

        if (keyTab) {
            event.preventDefault();
            event.stopPropagation();

            // If custom tab handler is provided, call it
            if (this.props.onCustomTabNavigation) {
                // Use the actual active element's hierarchy index if available
                // This is more reliable than the state's focusedHierarchyIndex which may be mid-update
                let currentIndex = (this.state as ReactJSONListState).focusedHierarchyIndex;

                // Try to find the hierarchy index from the actual focused element
                const activeElement = document.activeElement as HTMLElement;
                if (activeElement && activeElement.id) {
                    // Check if it's an input element in a shell
                    let el: HTMLElement | null = activeElement;
                    while (el) {
                        const shellId = el.id;
                        if (shellId && /^\d+$/.test(shellId)) {
                            const idx = parseInt(shellId, 10);
                            if (this.hierarchyFlatMap.some(e => e.hierarchyIndex === idx)) {
                                currentIndex = idx;
                                break;
                            }
                        }
                        el = el.parentElement;
                    }
                }

                const result = this.props.onCustomTabNavigation(event, currentIndex, event.shiftKey, this.hierarchyFlatMap, this.props.jsonData);

                // Check if result is an object with hierarchyIndex to focus
                if (result && typeof result === 'object' && result.type === 'focusHierarchyIndex') {
                    // Expand ancestors if needed and focus the specified hierarchy index
                    const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === result.hierarchyIndex);
                    if (entry && result.requireEnterable !== false && entry.ancestors && entry.ancestors.length > 0) {
                        const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                        let needsUpdate = false;
                        entry.ancestors.forEach((ancestor) => {
                            if (ancestor && !ancestor[dataKey]) {
                                ancestor[dataKey] = true;
                                needsUpdate = true;
                            }
                        });

                        this.setState({
                            jsonData: (this.state as ReactJSONListState).jsonData,
                            focusedHierarchyIndex: result.requireEnterable ? (this.state as ReactJSONListState).focusedHierarchyIndex : result.hierarchyIndex,
                            rowCount: needsUpdate ? -1 : (this.state as ReactJSONListState).rowCount,
                        }, () => {
                            this.performFocusEntry(result.hierarchyIndex, result.requireEnterable, this.getNavigationScrollLeft());
                        });
                    } else {
                        this.setState({
                            focusedHierarchyIndex: result.requireEnterable ? (this.state as ReactJSONListState).focusedHierarchyIndex : result.hierarchyIndex
                        }, () => {
                            this.performFocusEntry(result.hierarchyIndex, result.requireEnterable, this.getNavigationScrollLeft());
                        });
                    }
                    return;
                } else if (result === true) {
                    // Custom handler took care of it
                    return;
                }
            }

            // Default tab behavior
            this.moveTabFocus(event.shiftKey ? 'up' : 'down', event.shiftKey, event.ctrlKey);
            return;
        }

        if (keyEnter || keySpace) {
            event.preventDefault();
            event.stopPropagation();

            const { focusedHierarchyIndex } = this.state as ReactJSONListState;
            const focusedEntry = focusedHierarchyIndex !== undefined
                ? this.hierarchyFlatMap.find(e => e.hierarchyIndex === focusedHierarchyIndex)
                : null;

            if (this.props.onKeyDown && focusedEntry) {
                this.props.onKeyDown(focusedEntry.obj, event.key, focusedHierarchyIndex, event.shiftKey, event.ctrlKey, event.altKey);
            }

            // Try to activate selectable input (radio/checkbox)
            const didActivate = this.activateFocusedSelectableInput(event);

            if (didActivate) {

                // Use requestAnimationFrame to preserve state after JSP handlers complete
                requestAnimationFrame(() => {
                    const currentFocused = (this.state as ReactJSONListState).focusedHierarchyIndex;
                    if (currentFocused !== focusedHierarchyIndex) {
                        this.setState({ focusedHierarchyIndex: focusedHierarchyIndex });
                    }
                });
                return;
            }

            // If it's an accordion and Enter was pressed, toggle expand/collapse
            if (keyEnter && focusedEntry && focusedEntry.isAccordion) {
                const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
                const isCurrentlyExpanded = !!focusedEntry.obj[dataKey];
                focusedEntry.obj[dataKey] = !isCurrentlyExpanded;
                this.onClick(focusedEntry.obj, focusedEntry.key, focusedEntry.parentObj, focusedEntry.parentKey, focusedEntry.arrayIndex, focusedEntry.hierarchyIndex, event.shiftKey, event.ctrlKey, false);
                this.setState({ jsonData: (this.state as ReactJSONListState).jsonData });
            }
            return;
        }

        if (keyUp || keyDown) {
            event.preventDefault();
            event.stopPropagation();
            this.moveFocusInFlatMap(
                keyDown ? 'down' : 'up',
                event.key,
                event.shiftKey,
                event.ctrlKey
            );
            return;
        }

        if (keyLeft || keyRight) {
            const { focusedHierarchyIndex } = this.state as ReactJSONListState;
            if (focusedHierarchyIndex === undefined || focusedHierarchyIndex === -1) return;

            const entry = this.hierarchyFlatMap.find(e => e.hierarchyIndex === focusedHierarchyIndex);
            if (!entry || !entry.isAccordion) return;

            event.preventDefault();
            event.stopPropagation();

            const dataKey = (null != this.props.dataKey) ? this.props.dataKey : 'isExpanded';
            const isCurrentlyExpanded = !!entry.obj[dataKey];

            if (keyRight && !isCurrentlyExpanded) {
                this.onClick(entry.obj, entry.key, entry.parentObj, entry.parentKey, entry.arrayIndex, entry.hierarchyIndex, event.shiftKey, event.ctrlKey, false);
                entry.obj[dataKey] = true;
                this.setState({ jsonData: (this.state as ReactJSONListState).jsonData });
            } else if (keyLeft && isCurrentlyExpanded) {
                this.onClick(entry.obj, entry.key, entry.parentObj, entry.parentKey, entry.arrayIndex, entry.hierarchyIndex, event.shiftKey, event.ctrlKey, false);
                entry.obj[dataKey] = false;
                this.setState({ jsonData: (this.state as ReactJSONListState).jsonData });
            }
        }
    }

    onKeyUp(event: any) {
        if (!this.props.enableKeyboardNavigation) return;

        const keyEnter = event.key === 'Enter';
        const keySpace = event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space';
        if (!(keyEnter || keySpace)) return;

        const target = event.target as HTMLElement;
        const isTextarea = target.tagName === 'TEXTAREA';
        const isInput = target.tagName === 'INPUT';
        const isSelect = target.tagName === 'SELECT';
        const isContentEditable = !!target.isContentEditable;
        const inputType = isInput ? (((target as HTMLInputElement).type || '').toLowerCase()) : '';
        const isSelectableInput = inputType === 'radio' || inputType === 'checkbox';
        const isEditableInput = isTextarea || isSelect || isContentEditable || (isInput && !isSelectableInput);

        if (isEditableInput) {
            return;
        }

        const { focusedHierarchyIndex } = this.state as ReactJSONListState;
        const entry = focusedHierarchyIndex !== undefined
            ? this.hierarchyFlatMap.find(e => e.hierarchyIndex === focusedHierarchyIndex)
            : null;

        if (this.props.onKeyUp && entry) {
            this.props.onKeyUp(entry.obj, event.key, focusedHierarchyIndex, event.shiftKey, event.ctrlKey, event.altKey);
        }

        // DO NOT activate on keyUp - activation happens on keyDown only
        // Activating on both causes double-toggle of checkboxes
    }

    render() {
        const activeEl = document.activeElement;
        const activeIsTextarea = activeEl && activeEl.tagName === 'TEXTAREA';

        this.foundPrevRow = false;
        this.returnNextRow = false;
        this.foundParentRow = false;
        this.foundCurrentRow = false;

        const currentFocusedIndex = (this.state as ReactJSONListState).focusedHierarchyIndex;

        if (this.props.enableKeyboardNavigation) {
            this.effectiveFocusedIndex = currentFocusedIndex;
        } else {
            this.effectiveFocusedIndex = undefined;
        }

        // Reset flat map and totalRowCount for the real render pass
        this.hierarchyFlatMap = [];
        this.totalRowCount = 0;

        return <div ref={this.listRowRef} id={this.props.id} className={this.props.css} style={this.props.style} onScroll={this.onScroll} onKeyDown={this.onKeyDown} onKeyUp={this.onKeyUp} tabIndex={0} onFocus={this.handleElementFocus} data-expanding-all={(this.state as ReactJSONListState).isExpandingAll ? "true" : "false"}>
            <div className={this.props.divContainerCSS} style={this.props.divContainerStyle}>
                {<table className="categoryAllHide">
                    <tr>
                        <td><input id={this.props.id + "_highlight"} onClick={this.highlightRow} value={(this.state as ReactJSONListState).highlightKey} autoComplete="off" ></input></td>
                        <td>
                            HIDDEN HIGHLIGHT INDEX
                        </td>

                        <td><input id={this.props.hiddenTotalCountID} value={this.getTotal((this.state as ReactJSONListState).jsonData)} autoComplete="off"/>
                        </td>
                        <td>
                            HIDDEN TOTAL COUNT
                        </td>
                    </tr><tr>
                    <td><input
                        id={this.props.disableID}
                        type="checkbox"
                        checked={(this.state as ReactJSONListState).disabled}
                    /></td>
                    <td>
                        HIDDEN DISABLE BUTTON
                    </td>
                    {(null != this.props.getJSONData) && <td><button type="button" id={this.props.id + "_getJSONData"} onClick={event => {this.getJSONData()}}>HIDDEN GET JSON DATA BUTTON</button></td>}
                    <td><button type="button" id={this.props.id + "_expandAll"} onClick={event => {this.onExpandAll(event)}}>HIDDEN EXPAND ALL BUTTON</button></td>
                    <td><button type="button" id={this.props.id + "_collapseAll"} onClick={event => {this.onCollapseAll(event)}}>HIDDEN COLLAPSE ALL BUTTON</button></td>
                </tr>
                    <tr>
                        <td><button type="button" id={this.props.id + "_up"} onClick={event => {this.onKeyDown(new KeyboardEvent('keyup', { key: 'ArrowUp'}))}}>HIDDEN UP BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_down"} onClick={event => {this.onKeyDown(new KeyboardEvent('keydown', { key: 'ArrowDown'}))}}>HIDDEN DOWN BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_left"} onClick={event => {this.onKeyDown(new KeyboardEvent('keyleft', { key: 'ArrowLeft'}))}}>HIDDEN LEFT BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_right"} onClick={event => {this.onKeyDown(new KeyboardEvent('keyright', { key: 'ArrowRight'}))}}>HIDDEN RIGHT BUTTON</button></td>
                        <td><button type="button" id={this.props.id + "_scrollIntoView"} onClick={this.executeScroll}>SCROLL INTO VIEW BUTTON</button></td>
                    </tr>
                </table>
                }
                {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                {
                    this.getAccordionRow((this.state as ReactJSONListState).jsonData, {}, "", -1, {childCount: 0}, 0, true, [])
                }
            </div>
        </div>;
    }
}
